import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid';                 // ajouté
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import GlobalLayout from '../GlobalLayout';
import { getClause, updateClause, createClause } from '../../services/admin_api';  // ajout getApps

// 1) Import du core ACE
import 'ace-builds/src-noconflict/ace';
// 2) Import des modes dont dépend votre mode personnalisé
import 'ace-builds/src-noconflict/mode-pgsql';
import 'ace-builds/src-noconflict/mode-twig';
// 3) Import de votre mode combiné
import 'ace-builds/src-noconflict/mode-pgsql_twig';
// 4) Import du thème
import 'ace-builds/src-noconflict/theme-monokai';

import AceEditor from 'react-ace';

const EditClause = () => {
    const { app, category } = useParams();
    const isEdit = true;
    const navigate = useNavigate();

    console.log(app, category);

    const [clauseData, setClauseData] = useState({
        id: '',
        template: '',
        app_id: '',
        category: '',
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    // Charge la query si on édite
    useEffect(() => {
        if (!isEdit) {
            setLoading(false);
            return;
        }
        const fetchClause = async () => {
            try {
                const data = await getClause(app, category);
                setClauseData({
                    id: data.id,
                    template: data.template,
                    app_id: data.app_id,
                    category: data.category,
                });
                setError('');
            } catch {
                setError('Erreur lors du chargement des clauses.');
            } finally {
                setLoading(false);
            }
        };
        fetchClause();
    }, [app, category, isEdit]);

    const handleTemplateChange = (newValue) => {
        setClauseData({
            ...clauseData,
            template: newValue,
        });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            if (isEdit) {
                await updateClause(clauseData.id, clauseData);
                alert('Clauses misent à jour avec succès.');
            } else {
                await createClause(clauseData);
                alert('Clauses crééent avec succès.');
            }
            navigate(-1)
        } catch {
            setError(`Erreur lors de la ${isEdit ? 'mise à jour' : 'création'} de la Query.`);
        }
    };

    if (loading) return <div>Chargement...</div>;

    return (
        <GlobalLayout>
            <div style={{ padding: '1rem', margin: '0 auto' }}>
                <h1>{isEdit ? 'Éditer les Clauses' : 'Nouvelles Clauses'}</h1>
                {error && <p style={{ color: 'red' }}>{error}</p>}
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, sm: 12 }}>
                            <InputLabel style={{ marginBottom: 8 }}>Template</InputLabel>
                            <AceEditor
                                mode="pgsql_twig"
                                theme="monokai"
                                name="ace-editor"
                                onChange={handleTemplateChange}
                                value={clauseData.template}
                                width="100%"
                                height="800px"
                                setOptions={{ useWorker: false }}
                            />
                        </Grid>
                        <Grid size={12}>
                            <Button variant="contained" color="primary" type="submit">
                                {isEdit ? 'Enregistrer' : 'Créer'}
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </div>
        </GlobalLayout>
    );
};

export default EditClause;